import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { UiStore } from 'stores';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

// util
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

export class JoinProgramConfirmationController implements Controller {
  public pageId = pageNames.joinProgramConfirmation;
  public path = '/:localeName/join-program-confirmation';
  public routeName = 'join-program-confirmation';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "join-program-confirmation-page" */ '../views/join-program-confirmation-page'),
  );

  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const context = request.context;

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'PZ SignUp Confirmation' }) as Promise<PageData>;
  }
}
